import { gql } from '@apollo/client';

export interface IGetWorkShiftDataResponse {
  getWorkShiftPaymentOverviewData: {
    id: number;
  } | null;
}
export const GET_WORKSHIFT_DATA = gql`
  query getWorkShiftPaymentOverviewData {
    getWorkShiftPaymentOverviewData {
      id
    }
  }
`;
